import React from 'react';
import _get from 'lodash/get';
import { FormControlLabel, makeStyles, Button } from '@material-ui/core';
import { sharedStyles } from './seriesSharedStyles';
import { SeriesCheckbox } from './SeriesCheckbox';

const useStyles = makeStyles(theme => ({
  ...sharedStyles(theme),
  formLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: props => props.fontSize,
    },
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(4),
    },
  },
}));

export const SeriesResourceCardActions = ({
  seriesSiteCopy,
  completedResourcesIds,
  resource,
  resources,
  onSeriesComplete,
  handleNext,
  activeResourceIdx,
  completed,
  onChange,
  fontSize,
  isSeriesComplete,
  showCompleteCheckbox = true,
  isManualSeriesCompletion = true,
}) => {
  const classes = useStyles({ fontSize });

  const completedResources = resources.filter(r =>
    completedResourcesIds.includes(r.sys.id),
  );

  // If resource is last to be completed, disable next button till series is completed
  // This is to prevent user from clicking next before series is completed for last resource completion
  const allResourcesCompleted =
    !!resources.length && resources.length === completedResources.length;
  const disableNext =
    !completed || (allResourcesCompleted && !isSeriesComplete);

  const isNextButtonDisabled =
    completedResources.length === resources.length ||
    (resources.length - completedResources.length === 1 &&
      !completedResourcesIds.includes(resource.sys.id));

  return (
    <>
      {showCompleteCheckbox && (
        <FormControlLabel
          className={classes.formLabel}
          control={
            <SeriesCheckbox
              checked={completed}
              onChange={onChange}
              name="complete"
            />
          }
          label={_get(seriesSiteCopy, 'pageCopy.markCompleted')}
        />
      )}
      {isNextButtonDisabled && isManualSeriesCompletion ? (
        <Button
          className={classes.nextButton}
          variant="contained"
          color="primary"
          onClick={onSeriesComplete}
          disabled={isSeriesComplete}
        >
          {_get(seriesSiteCopy, 'pageCopy.complete')}
        </Button>
      ) : (
        <Button
          className={classes.nextButton}
          variant="contained"
          color="primary"
          onClick={() => handleNext(activeResourceIdx, completed)}
          disabled={!isManualSeriesCompletion && disableNext}
        >
          {_get(seriesSiteCopy, 'pageCopy.next')}
        </Button>
      )}
    </>
  );
};
